var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-pre__wrapper",class:( _obj = {}, _obj[_vm.extraClass] = true, _obj )},[(_vm.label)?_c('span',{staticClass:"v-pre__label"},[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('div',{staticClass:"v-pre__content"},[_c('div',{staticClass:"v-pre"},[_c('span',[_vm._v(" "+_vm._s(_vm.text)+" ")])]),(_vm.withCopy)?_c('VCopyIcon',{attrs:{"copyText":_vm.text}}):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }